import React, { useState, useCallback, useEffect } from 'react';
import useApi from '../../api/useApi';

function index({ showNotification }) {
  const passwordDataModel = {
    oldPwd: '',
    newPwd: '',
    confirmPwd: '',
  };

  const [passwordData, setPasswordData] = useState(passwordDataModel);
  const [passwordState, changePassword] = useApi();

  const handlePasswordInputChange = useCallback((e) =>
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value })
  );

  const handlePasswordChange = (e) => {
    e.preventDefault();

    let err = [];

    if (!passwordData.oldPwd) err.push('Old Password');
    if (!passwordData.newPwd) err.push('New Password');
    if (!passwordData.confirmPwd) err.push('Confirm Password');

    if (err.length > 0) {
      showNotification('error', `Please fill ${err.join(', ')} field(s)`);
      return;
    }

    if (passwordData.confirmPwd !== passwordData.newPwd) {
      showNotification('error', `Confirm Password should match New Password`);
      return;
    }

    const body = {
      oldPassword: passwordData.oldPwd,
      newPassword: passwordData.newPwd,
    };

    changePassword('/changePassword', 'POST', body);
  };

  useEffect(() => {
    if (!passwordState.isLoading && !passwordState.isError && passwordState.data) {
      showNotification('success', 'Password updated Successfully');
    }
    if (passwordState.isError) {
      showNotification('sucerrorcess', 'Unable to update password');
    }
  }, [passwordState]);

  return (
    <div>
      <p className="mt-4 font-bold text-lg text-textBlue1">Change Password</p>
      <form className="mt-3 flex flex-wrap" onSubmit={handlePasswordChange} autoComplete="off">
        <div className=" w-1/3 items-center  my-3.5">
          <label htmlFor="oldPwd" className="mb-1 block text-parameter  text-sm">
            OLD PASSWORD
          </label>
          <input
            type="password"
            value={passwordData.oldPwd}
            name="oldPwd"
            className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handlePasswordInputChange}
          />
        </div>

        <div className=" w-1/3 items-center  my-3.5">
          <label htmlFor="newPwd" className="mb-1 block text-parameter  text-sm">
            NEW PASSWORD
          </label>
          <input
            type="password"
            value={passwordData.newPwd}
            name="newPwd"
            className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handlePasswordInputChange}
          />
        </div>

        <div className=" w-1/3 items-center  my-3.5">
          <label htmlFor="confirmPwd" className="mb-1 block text-parameter  text-sm">
            CONFIRM PASSWORD
          </label>
          <input
            type="password"
            value={passwordData.confirmPwd}
            name="confirmPwd"
            className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handlePasswordInputChange}
          />
        </div>

        <div className="flex w-full items-center justify-end  mt-6 relative">
          {passwordState.isLoading ? (
            <img src="assets/img/loader.svg" className="w-16 mr-6 ml-auto" alt="" />
          ) : (
            <input
              type="submit"
              value="Save"
              className="rounded-lg focus:outline-none w-1/4 mr-8 h-10 text-textBlue1 cursor-pointer "
              style={{ background: '#16406D33', border: '1px solid #16406D' }}
            />
          )}
        </div>
      </form>
    </div>
  );
}

export default index;
